module.exports = __webpack_public_path__ + "media/images/teams/logo__44-c34522a2539f34bd702b5e68c4376310.svg";